<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed inset-0 flex items-center justify-center w-full h-screen bg-smoke-800"
      :class="options.background"
      @click.self="close"
    >
      <div
        class="relative flex w-full max-w-sm max-h-screen p-8 px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl dark:bg-gray-800 sm:my-8 sm:align-middle sm:w-full sm:p-6"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
        :class="options.modal"
      >
        <div class="w-full max-h-screenoverflow-auto">
          <slot />
          <div class="flex items-center justify-between w-full">
            <slot name="footer" />
            <button
              type="button"
              class="inline-flex justify-center text-white bg-black border border-transparent btn dark:bg-gray-600 hover:bg-gray-700 focus:outline-none"
              @click.prevent="close"
            >
              Lukk
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }
      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted: function () {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
